// ./verdandi/PosButtons.tsx
import React, { useState } from "react";
import styled from "styled-components";
import ProgressButton from "../utils/ProgressButton";
import { generateRandomNumber } from "../utils/RandomNumberGenerator";
import { getWorstPosProgress } from "../utils/CounterFormat";



const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 0.8rem;
`;


const PosButton = styled.button`
  min-width: 4rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  background: var(--color-primary-600);
  color: #fff;
  font-weight: 600;
  box-shadow: var(--shadow-div-sm);

  &:hover {
    background: var(--color-primary-700);
  }
`;



function PosButtons({ posItems, locations, onSelect }) {
  const [selectedId, setSelectedId] = useState(null);

  const handleButtonClick = (id) => {
    setSelectedId(id);
    onSelect?.(id);
  };

  return (
    <>
      <Grid>
        {posItems.map((pos) => (
        <ProgressButton
          key={pos}
          id={pos}
          label={"POS " + pos}
          progress={getWorstPosProgress(locations, pos) ?? 0}
          isActive={pos === selectedId}
          onClick={handleButtonClick}
        />
        ))}
      </Grid>

    </>
  );
}

export default PosButtons;
